import * as React from 'react'

import { cn } from '@/lib/utils'

import BlogViewStats from '@/components/common/blog-view-stats'
import GroupSharingButton from '@/components/common/group-sharing-button'

import { BlogType } from '@/types/blog.type'

interface BlogActionContainerProps {
  className?: string
  blog?: BlogType
}

function BlogActionContainer({ className, blog }: BlogActionContainerProps): JSX.Element {
  return (
    <div className={cn(className, 'flex flex-col sm:flex-row gap-4')}>
      {blog?.id && (
        <BlogViewStats
          blogId={blog.id}
          showIcon={true}
          showTrending={true}
          showUniqueOnly={false}
          showUnique={false}
          compact={false}
          className="text-sm"
        />
      )}

      <GroupSharingButton
        title={blog?.title || 'FSDS Blog'}
        description={blog?.metaDescription || 'Read this article on FSDS'}
        hashtags={['blog', 'datascience', 'fsds']}
      />
    </div>
  )
}

export default BlogActionContainer
